import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=3540c552&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=js&"
export * from "./storage.vue?vue&type=script&lang=js&"
import style0 from "./storage.vue?vue&type=style&index=0&id=3540c552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540c552",
  null
  
)

export default component.exports